import React from 'react';
import pluralize from 'pluralize';

interface AddUserConfirmationProps {
  selectedRole: string;
  uniqUsersLength: number;
  uniqSpacesLength: number;
  roles?: Array<{ id: string; title?: string; name?: string; _id?: string }>;
  parentClasses?: {
    bold?: string;
  };
}

const AddUserConfirmation = ({
  parentClasses,
  uniqUsersLength,
  selectedRole,
  uniqSpacesLength,
  roles = [],
}: AddUserConfirmationProps) => {
  // Get role name from roleId
  const getRoleName = (roleId: string) => {
    if (!roleId || !roles || roles.length === 0) {
      return 'educator'; // fallback
    }
    const role = roles.find((r) => (r.id || r._id) === roleId);
    if (role) {
      return role.title || role.name || 'educator';
    }
    return 'educator';
  };

  const roleName = getRoleName(selectedRole);

  return (
    <span>
      You are adding{' '}
      <span className={parentClasses?.bold}>
        {pluralize('user', uniqUsersLength, true)}
      </span>{' '}
      as {pluralize(roleName, uniqUsersLength, false)} in{' '}
      <span className={parentClasses?.bold}>
        {pluralize('space', uniqSpacesLength, true)}
      </span>
    </span>
  );
};

export default AddUserConfirmation;
